import * as TrackingService from 'common/services/tracking.service';
import moment from 'moment';
import {
  SEARCH_DATE_FORMAT,
  SESSION_STORAGE_KEYS,
  TRACKING
} from 'common/constants/constants';
import { daysBetweenDates } from '@linearb/linui-utils';
import { momentDateValidator } from 'common/utils/time.utils';
import { getRetentionDaysByLicense } from 'common/utils/utils';
import RangePicker from 'components/base/RangePicker';
import { Flex } from 'components/base/layout-components';
import { getTeamsNames } from './TeamsDropdown';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import GranularityDropdown from './GranularityDropdown';
import { DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS } from '../../../../dashboard/doraV2/dashboard.doraV2.freeTier.consts';
import { Filter30daysTooltip } from 'connected-components/TopBar/Filter30DaysTooltip';

export const getNonEditModeFilters = ({
  isOnEditMode,
  reportName,
  retentionDays,
  license,
  filters,
  isCustom,
  isPmCustomDashboard,
  isAllControbutorsTeamSelected
}) => {
  if (isOnEditMode) {
    return [];
  }
  const { start_date, end_date } = filters.selectedTimeRanges;
  const stringTomorrow = moment().add(1, 'day').format(SEARCH_DATE_FORMAT);
  const disableDateRangeByLicense = date => {
    return isAllControbutorsTeamSelected
      ? date.isBefore(
          moment().subtract(DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS + 1, 'day')
        ) || date.isAfter(moment())
      : date.isSameOrAfter(moment(stringTomorrow));
  };

  const isLessThan7days =
    daysBetweenDates(
      momentDateValidator(start_date),
      momentDateValidator(end_date)
    ) < 7;

  const DateRangePicker = (
    <RangePicker
      highlight={isLessThan7days}
      name={reportName}
      dataRetentionDays={!isAllControbutorsTeamSelected && retentionDays}
      licenseRetention={getRetentionDaysByLicense(license)}
      height='2.1rem'
      startDate={momentDateValidator(start_date)}
      endDate={momentDateValidator(end_date)}
      isOutsideRange={date => disableDateRangeByLicense(date)}
      onDatesChange={({ endDate, startDate }) => {
        const newTimeframe = {
          end_date: moment(endDate).format(SEARCH_DATE_FORMAT),
          start_date: moment(startDate).format(SEARCH_DATE_FORMAT)
        };
        TrackingService.logEvent(TRACKING.EVENTS.FILTER, {
          page: TRACKING.PAGES.METRICS,
          filter_name: TRACKING.FILTER.TIMEFRAME,
          ...(isCustom
            ? { page_tab: TRACKING.PAGE_TABS.CUSTOM_DASHBOARD }
            : {}),
          team_names: getTeamsNames(filters.globallySelectedTeams)
        });
        BrowserStorageAccessor().session.set(
          SESSION_STORAGE_KEYS.CUSTOM_DASHBOARD_TIMEFRAME,
          JSON.stringify(newTimeframe)
        );
        filters.setSelectedTimeRanges(newTimeframe);
      }}
    />
  );

  return [
    <Flex width='17rem' key='DateRange'>
      {isLessThan7days ? (
        <Filter30daysTooltip>{DateRangePicker}</Filter30daysTooltip>
      ) : (
        DateRangePicker
      )}
    </Flex>,
    <GranularityDropdown
      key='GranularityDropdown'
      globallySelectedTeams={filters.globallySelectedTeams}
      selectedGranularity={filters.selectedGranularity}
      onChange={granularity =>
        filters.setSelectedGranularity(granularity || null)
      }
      isPmCustomDashboard={isPmCustomDashboard}
    />
  ];
};
